import { isDefinedString, isPositiveNumber, reduce } from "et3-type-guards";
import { isNumber, isString } from "lodash";
import {
  REPORT_EVENTS,
  TEMPORARY_BAN_EVENTS,
  STATUS_EVENTS,
  ALWAYS_SHOW_EXTRA_DATA_EVENTS
} from "../constants/admin-events-constants";
import i18n from "../constants/i18n";

import getAuditStore from "../stores/auditor-store/audit-store";
import getTBWStore from "../stores/tbw-store";
import { StringOrNumber } from "../Types";
import { getFormattedTBWExtraDataArray } from "./et3-get-client-readable-text";

export const getEventList = () => {
  const typeInput = getAuditStore().typeInputAudit.get().value;
  if (typeInput === "report") {
    const eventID = getTBWStore().TBWEventId.get();
    const eventsList = getAuditStore().adminReportEventsData.get().eventsList;
    const dataRow = eventsList.filter((values) => values.id === eventID);
    const userId: StringOrNumber = reduce(() => dataRow[0].userId, 0);
    const type = reduce(() => dataRow[0].type, "");
    const userIDNumber = isNumber(userId) ? userId : parseInt(userId, 10);
    const eventIDNumber = isNumber(eventID) ? eventID : parseInt(eventID, 10);
    const eventType = isString(type) ? type : "";
    return { userIDNumber, eventIDNumber, eventType };
  } else {
    const eventID = getTBWStore().TBWEventId.get();
    const eventsList = getAuditStore().adminEventsData.get().eventsList;
    const dataRow = eventsList.filter((values) => values.id === eventID);
    const userId: StringOrNumber = reduce(() => dataRow[0].userId, 0);
    const type = reduce(() => dataRow[0].type, "");
    const userIDNumber = isNumber(userId) ? userId : parseInt(userId, 10);
    const eventIDNumber = isNumber(eventID) ? eventID : parseInt(eventID, 10);
    const eventType = isString(type) ? type : "";
    return { userIDNumber, eventIDNumber, eventType };
  }
};

export const getExtraDataParts = ({
  eventType,
  description,
  reportID,
  investigationCaseID,
  temporaryBanUntil,
  temporaryBanNumberOfDays,
  extraData
}: {
  eventType: string;
  description: string;
  reportID: number;
  investigationCaseID: number;
  temporaryBanUntil: string;
  temporaryBanNumberOfDays: number;
  extraData: string;
}) => {
  const reducedDescription = reduce(() => description, "");
  const reducedReportID = reduce(() => reportID, -1);

  let textParts: string[] = [];

  if (isDefinedString(reducedDescription)) {
    textParts.push(reducedDescription);
  }

  if (
    ALWAYS_SHOW_EXTRA_DATA_EVENTS.includes(eventType) &&
    isDefinedString(getFormattedTBWExtraDataArray(extraData))
  ) {
    textParts.unshift(getFormattedTBWExtraDataArray(extraData));
  }

  if (REPORT_EVENTS.includes(eventType)) {
    textParts = [`${reducedReportID}`];
  } else if (TEMPORARY_BAN_EVENTS.includes(eventType)) {
    if (eventType !== "BANNED") {
      if (
        isDefinedString(temporaryBanUntil) &&
        isPositiveNumber(temporaryBanNumberOfDays)
      ) {
        textParts.push(
          `${i18n.get("BAN_UNTIL")} ${temporaryBanUntil}`,
          `${i18n.get("NUMBER_OF_DAYS")} ${temporaryBanNumberOfDays}`
        );
      }
    }

    if (isPositiveNumber(investigationCaseID)) {
      textParts.push(`${i18n.get("INVESTIGATION_ID")} ${investigationCaseID}`);
    }

    if (isPositiveNumber(reducedReportID)) {
      textParts.push(`${i18n.get("REPORT_ID")} ${reducedReportID}`);
    }
  } else if (STATUS_EVENTS.includes(eventType)) {
    if (isPositiveNumber(investigationCaseID)) {
      textParts.push(`${i18n.get("INVESTIGATION_ID")} ${investigationCaseID}`);
    } else if (isPositiveNumber(reportID)) {
      textParts.push(`${i18n.get("REPORT_ID")} ${reportID}`);
    }
  }

  return textParts;
};
